import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { formatDate } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApicallService } from 'src/app/Apicalls/apicall.service';
import { UtilsService } from 'src/app/Apicalls/UtilsService/utils.service';

@Component({
  selector: 'app-manage-site-dialog',
  templateUrl: './manage-site-dialog.component.html',
  styleUrls: ['./manage-site-dialog.component.scss'],
})
export class ManageSiteDialogComponent {
  today: string = new Date().toISOString().split('T')[0];
  isSmallScreen = false;
  isLoadingfirst: boolean = false;
  isDarkTheme = false;
  addsitename: any;
  addtype: any;
  addname: any;
  enrollmentDate: any;
  editEnrollmentDate: any;
  selectedStatus: boolean | null = null;
  selectedType: string | null = null;
  statusoption = [
    { label: 'Active', value: true },
    { label: 'Inactive', value: false },
  ];
  typeOptions = [
    { label: 'Plant', value: 'P' },
    { label: 'Site', value: 'S' },
  ];
    token = localStorage.getItem('user');
  addemail: any;
  selectedRole: any;
  addphone: any;
  description: any;
  editSiteId: any;
  editSiteName: any;
  editDescription: any;
  deleteSiteid: any;
  addSiteName: any;
  siteDetails: any;
  address: string = '';
  editAddress: string = '';
  company: string = '';
  editCompany: string = '';
  formattedDate: any;
  permission: any;
  constructor(
    public dialogRef: MatDialogRef<ManageSiteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private apiCallsService: ApicallService,
    private utils: UtilsService,
    private snackBar: MatSnackBar,
    private breakpointObserver: BreakpointObserver
  ) {}
  ngOnInit() {
    this.breakpointObserver
      .observe([Breakpoints.Handset])
      .subscribe((result) => {
        this.isSmallScreen = result.matches;
      });
    this.parseToken();
    this.isLoadingfirst = false;
    const clickedValue = this.data.clicked;
    if (clickedValue == 1) {
      this.data.clicked;
    } else if (clickedValue == 2) {
      this.data.clicked;
      this.editSiteId = this.data.passEditData.id;
      this.editSiteName = this.data.passEditData.name;
      this.selectedType = this.data.passEditData.site_plant_type;
      this.editDescription = this.data.passEditData.description;
      this.selectedStatus = this.data.passEditData.status;
      this.editEnrollmentDate = this.data.passEditData.enrollment_on;
      this.editAddress = this.data.passEditData.address;
      this.editCompany = this.data.passEditData.company;
      this.editEnrollmentDate = this.data.passEditData.enrolled_on;
      this.formattedDate = this.convertEpochToDate(this.editEnrollmentDate);
    } else if (clickedValue == 3) {
      this.data.clicked;
      this.deleteSiteid = this.data.passDeleteData.id;
    }
  }
  convertEpochToDate(epoch: number): string {
    return formatDate(new Date(epoch), 'yyyy-MM-dd', 'en-US');
  }
  parseToken() {
    let token: any = this.token;
    const tokenPayload = token.split('.')[1];
    const decodedPayload = atob(tokenPayload);
    const decodedPayloadJson = JSON.parse(decodedPayload);
    this.permission = decodedPayloadJson.permission;
  }
  addSite() {
    const formData = {
      name: this.addsitename,
      site_plant_type: this.selectedType,
      status: this.selectedStatus,
      description: this.description,
      enrolled_on: new Date(this.enrollmentDate).getTime(),
      address: this.address,
      company: this.company,
    };
    this.isLoadingfirst = true;
    this.apiCallsService.AddSite(formData).subscribe({
      next: (response) => {
        if (response.message) {
          setTimeout(() => {
            this.isLoadingfirst = false;
            this.utils.notifyUserAdded();
            this.closed(true);
            this.snackBar.open(response.message, 'Close', {
              duration: 5000,
              verticalPosition: 'bottom',
              horizontalPosition: 'end',
            });
          }, 1000);
        }
      },
      error: (error) => {
        console.log(error);
        this.isLoadingfirst = false;
        this.closed(true);
        this.snackBar.open(error.error.message, 'Close', {
          duration: 5000,
          verticalPosition: 'bottom',
          horizontalPosition: 'end',
        });
      },
    });
  }
  editSite() {
    const formData = {
      name: this.editSiteName,
      site_plant_type: this.selectedType,
      id: this.editSiteId,
      description: this.editDescription,
      status: this.selectedStatus,
      enrolled_on: new Date(this.formattedDate).getTime(),
      address: this.editAddress,
      company: this.editCompany,
    };
    this.isLoadingfirst = true;
    this.apiCallsService.EditSite(formData).subscribe({
      next: (response) => {
        if (response.message) {
          setTimeout(() => {
            this.isLoadingfirst = false;
            this.utils.notifyUserAdded();
            this.closed(true);
            this.snackBar.open(response.message, 'Close', {
              duration: 5000,
              verticalPosition: 'bottom',
              horizontalPosition: 'end',
            });
          }, 1000);
        }
      },
      error: (error) => {
        console.log(error);
        this.isLoadingfirst = false;
        this.closed(true);
        this.snackBar.open(error.error.message, 'Close', {
          duration: 5000,
          verticalPosition: 'bottom',
          horizontalPosition: 'end',
        });
      },
    });
  }
  DeleteSite() {
    this.isLoadingfirst = true;
    this.apiCallsService.DeleteSite(this.deleteSiteid).subscribe({
      next: (response) => {
        if (response.message) {
          setTimeout(() => {
            this.isLoadingfirst = false;
            this.utils.notifyUserAdded();
            this.closed(true);
            this.snackBar.open(response.message, 'Close', {
              duration: 5000,
              verticalPosition: 'bottom',
              horizontalPosition: 'end',
            });
          }, 1000);
        }
      },
      error: (error) => {
        console.log(error);
        this.isLoadingfirst = false;
        this.closed(true);
        this.snackBar.open(error.error.message, 'Close', {
          duration: 5000,
          verticalPosition: 'bottom',
          horizontalPosition: 'end',
        });
      },
    });
  }
  closed(success: boolean = false) {
    this.dialogRef.close(success);
  }
}
